export default "__VITE_ASSET__HC5t_OnE__"